
export function generateDatasetsBar(vars, variables) {
  return vars.map(({name, idvar, data}) => ({
    label: name,
    data: data.map(
      ({time, value}) => ({
        x: time,
        y: parseFloat(value)
      })
    ),
    type: "bar",
    pointRadius: 0,
    tension: 0,
    borderWidth: 2,
    fill: false,
    borderColor: variables[idvar].color,
    backgroundColor: variables[idvar].color,
  }));
}

export function generateDatasetsPie(vars, variables) {
  // console.log(vars, variables)
  return vars.map(({name, idvar, data}) => ({
    label: name,
    data: data.map(({value}) => parseFloat(value)),
    type: "pie",
    fill: false,
    tension: 0,
    borderWidth: 2,
    backgroundColor: variables[idvar].color,
    borderColor: variables[idvar].color,
  }));
};
